var exports = {
  "k": "container__ul6zu1",
  "S": "withoutActions__k3A7vk",
};

module.exports = exports;
